module.exports = __webpack_public_path__ + "static/media/uz.7f3b112b.svg";